export default {
  title: 'Moms og valuta',
  subtitle: 'Administrer de momskategorier, der bruges til prissætning af dine menupunkter.',
};
